var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 6 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00778b",
    d: "M0 0h6v3H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M1 1h5v1H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.598 1.5 0 3V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/bs.ef1ac5d710c38a791dd1d36790422105.svg";
export { ForwardRef as ReactComponent };